export default __webpack_public_path__ + "static/Miami-d6a70f608b9b0c7fc4cbfe4c950bcb2c.svg";